// Module
var code = "<div ng-if=\"$ctrl.isReady\"><div fine-uploader=\"$ctrl.uploadOptions\"></div></div>";
// Exports
module.exports = code;